import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'
import { MdDone, MdClose } from 'react-icons/lib/md';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getDateValue } from '../../utils/date';
import { withAuth } from '../../actions/';

class AETrackingViewOnly extends Component {
    constructor(props) {
        super(props);

        this.state = {
            aeTrack: props.aeTrack,
            showSavedMsg: false,
            toEdit: props.toEdit,
        };

        this.putAeTrack = this.putAeTrack.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ aeTrack: nextProps.aeTrack })
        this.setState({ toEdit: nextProps.toEdit })
    }

    getSelectLabels(id, values, name) {
        if (id !== undefined) {
            let label = _.find(this.props[values], function (s) { return s.id === id });
            if (label !== undefined)
                return label[name];
        }
        else return null;
    }

    putAeTrack() {
        const { aeTrack } = this.state;

        let method = 'put';
        let url = `projects/${aeTrack.projectId}/AETracking/${aeTrack.id}`;

        withAuth(
            { method, url, data: aeTrack },
            () => {
                this.setState({ showSavedMsg: true });
                toast.success('Saved Successfully!');
            },
            this.errorHandler
        )
    }

    render() {
        const { aeTrack } = this.state;
        const { isSustDir } = this.props.permissionsModule;

        return (
            <div>

                {this.state.showSavedMsg &&
                    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={2000}
                        position={'top-center'}
                    />}

                <div className="col s12 m6 l4">
                    <div className="boxed">
                        <div className="controls with-select">
                            <label>Job Type</label>
                            {this.getSelectLabels(aeTrack.jobTypeId, 'jobTypes_AE', 'jobType')}
                        </div>

                        <div className="controls date-control">
                            <label>Strategy Board Date</label>
                            {getDateValue(aeTrack.strategyBoardDate)}
                        </div>

                        <div className="controls date-control">
                            <label>Field Visit Date</label>
                            {getDateValue(aeTrack.fieldVisitDate)}
                        </div>

                        <div className="controls">
                            <span className="label span-inline">Pre-Schematic phase exists:</span>
                            <span className="value span-inline">{aeTrack.isPreSchematic ? 'Yes' : 'No'}</span>
                        </div>

                        <div className="controls with-select">
                            <label>Discipline</label>
                            {this.getSelectLabels(aeTrack.disciplineId, 'disciplines_AE', 'discipline')}
                        </div>

                        <div className="controls with-select">
                            <label>Design Source</label>
                            {this.getSelectLabels(aeTrack.designSourceId, 'designSources_AE', 'designSource')}
                        </div>
                    </div>
                </div>

                <div className="col s12 m6 l4">
                    <div className="boxed">
                        <div className="controls  with-select">
                            <label>Track</label>
                            {this.getSelectLabels(aeTrack.trackId, 'tracks_AE', 'track')}
                        </div>
                        <div className="row">
                            <div className="col s6">
                                {isSustDir
                                    ? <div className="row inner-box-content" id="innerContentCustomPadding">
                                        <div className="md-checkbox">
                                            <input id="sustDesign"
                                                type="checkbox"
                                                onChange={this.props.handleCheckboxChange('sustDes')}
                                                checked={aeTrack.sustDes} />
                                            <label htmlFor="sustDesign">Sust Des</label><span></span>
                                        </div>
                                    </div>
                                    : <div className="padding-top-bottom-2">
                                        <span> {aeTrack.sustDes
                                            ? <MdDone size={18} color="#008000" />
                                            : <MdClose size={18} color="#F4633D" />}
                                        </span> Sust Des
                                     </div>}
                            </div>
                            <div className="col s6">
                                <div className="padding-top-bottom-2">
                                    <span> {aeTrack.histPres
                                        ? <MdDone size={18} color="#008000" />
                                        : <MdClose size={18} color="#F4633D" />}
                                    </span> Hist Pres
                                 </div>
                            </div>
                        </div>

                        {isSustDir &&
                            <div className="col s12">
                                <button className="btn-save margin-bottom-075 margin-left-0" onClick={this.putAeTrack}>Save</button>
                            </div>}
                    </div>
                </div>

            </div>
        )
    }
}

AETrackingViewOnly.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissionsModule: PropTypes.object.isRequired,
    aeTrack: PropTypes.object.isRequired,
    jobTypes_AE: PropTypes.array.isRequired,
    disciplines_AE: PropTypes.array.isRequired,
    designSources_AE: PropTypes.array.isRequired,
    tracks_AE: PropTypes.array.isRequired,
    trackingMembers: PropTypes.array.isRequired
};

export default (AETrackingViewOnly);